import React, { memo } from 'react';
// eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
import { useFragment, graphql } from 'react-relay';
import { Box, xcss } from '@atlaskit/primitives';
import { IssueViewCreatedDateField } from '@atlassian/jira-issue-view-layout-meta-created-date-field/src/ui/index.tsx';
import { IssueViewResolvedDateField } from '@atlassian/jira-issue-view-layout-meta-resolved-date-field/src/ui/index.tsx';
import { IssueViewUpdatedDateField } from '@atlassian/jira-issue-view-layout-meta-updated-date-field/src/ui/index.tsx';
import { useUserPreferredWorkItemLayout } from '@atlassian/jira-issue-view-layout/src/services/main.tsx';
import UFOSegment from '@atlassian/jira-ufo-segment/src/index.tsx';
import type { ui_issueViewLayoutMetaContainer_IssueViewMetaContainer$key } from './__generated__/ui_issueViewLayoutMetaContainer_IssueViewMetaContainer.graphql';

export interface IssueViewMetaContainerProps {
	fragmentKey: ui_issueViewLayoutMetaContainer_IssueViewMetaContainer$key | null;
}

export const IssueViewMetaContainer: React.MemoExoticComponent<
	({ fragmentKey }: IssueViewMetaContainerProps) => React.JSX.Element
> = memo(({ fragmentKey }: IssueViewMetaContainerProps): React.JSX.Element => {
	const { userPreferredLayout } = useUserPreferredWorkItemLayout();

	const data = useFragment<ui_issueViewLayoutMetaContainer_IssueViewMetaContainer$key>(
		// eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
		graphql`
			fragment ui_issueViewLayoutMetaContainer_IssueViewMetaContainer on JiraIssue {
				createdField {
					...ui_issueViewLayoutMetaCreatedDateField_IssueViewCreatedDateField
				}
				updatedField {
					...ui_issueViewLayoutMetaUpdatedDateField_IssueViewUpdatedDateField
				}
				resolutionDateField {
					...ui_issueViewLayoutMetaResolvedDateField_IssueViewResolvedDateField
				}
			}
		`,
		fragmentKey,
	);

	return (
		<UFOSegment name="issue-timestamps">
			<Box xcss={[containerStyles, userPreferredLayout === 'WIDE' && wideViewStyle]}>
				{data?.createdField && <IssueViewCreatedDateField fragmentKey={data.createdField} />}
				{data?.updatedField && <IssueViewUpdatedDateField fragmentKey={data.updatedField} />}
				{data?.resolutionDateField && (
					<IssueViewResolvedDateField fragmentKey={data.resolutionDateField} />
				)}
			</Box>
		</UFOSegment>
	);
});

const containerStyles = xcss({
	marginTop: 'space.050',
	marginRight: 'space.200',
	flex: 1,
	paddingLeft: 'space.150',
});

const wideViewStyle = xcss({
	display: 'flex',
	gap: 'space.200',
});
